var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mx-0 mt-5 mb-4"},[_vm._v(" operator redirection pending status ")])
}
var staticRenderFns = []

export { render, staticRenderFns }